module.exports = __webpack_public_path__ + "media/images/lp_v6_img11-fa788eb1073d35c5c26a1425c0e71906.webp";